import { Http } from '@/lib/http';
export class InterestRateService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/interest-rates/';
  }
  updateInterestRate(payload) {
    return this.httpClient().patch(`${this.endpoint}`, payload);
  }
  getInterestRate() {
    return this.httpClient().get(`${this.endpoint}`);
  }
}
